import { useEffect } from "react";
import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";
import SetupSlideOverFormActions from "../SetupSlideOverFormActions";
import { useSlideOverSubmit } from "../useSlideOverSubmit";
import { useForm } from "../../useForm";

const initialValues = { name: "", description: "" };

export default function PriceRuleForm({
  priceRule,
  setOpen,
  actionCall,
  isEdit,
}) {
  const { values, setValues, handleInputChange } = useForm(
    initialValues,
    false,
  );
  const { submitting, runSubmit } = useSlideOverSubmit();

  useEffect(() => {
    setValues(
      priceRule
        ? {
            name: priceRule.name ?? "",
            description: priceRule.description ?? "",
          }
        : initialValues,
    );
  }, [priceRule, setValues]);

  const handleSubmit = (event) => {
    event.preventDefault();
    runSubmit(() => actionCall(values));
  };

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="flex items-start justify-between px-4 sm:px-6">
          <Dialog.Title className="text-base font-semibold text-gray-900">
            {isEdit ? `Edit ${priceRule.name}` : "Add price rule"}
          </Dialog.Title>
          <button
            type="button"
            onClick={() => setOpen({ open: false, childComponent: null })}
          >
            <XMarkIcon className="h-6 w-6 text-gray-400" />
          </button>
        </div>
        <div className="mt-6 space-y-4 px-4 sm:px-6">
          <Input
            label="Name"
            name="name"
            value={values.name}
            onChange={handleInputChange}
            labelOn
            type="text"
          />
          <div>
            <label className="block text-sm font-medium text-gray-900">
              Description
            </label>
            <textarea
              name="description"
              value={values.description}
              onChange={handleInputChange}
              rows={4}
              className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm"
            />
          </div>
        </div>
      </div>
      <SetupSlideOverFormActions
        setOpen={setOpen}
        isEdit={isEdit}
        submitting={submitting}
        onSubmit={handleSubmit}
      />
    </div>
  );
}
